const services = [
  { icon: 'ri-stethoscope-line', title: 'Consulta Médica Completa', desc: 'Avaliação integral da sua saúde com escuta atenta, exame clínico detalhado e orientações personalizadas.' },
  { icon: 'ri-user-heart-line', title: 'Acompanhamento de Idosos', desc: 'Cuidado contínuo e humanizado para idosos, com foco em autonomia, segurança e qualidade de vida.' },
  { icon: 'ri-shield-check-line', title: 'Prevenção e Controle de Doenças', desc: 'Estratégias preventivas individualizadas para evitar, controlar e gerenciar condições crônicas.' },
  { icon: 'ri-heart-pulse-line', title: 'Avaliação Geral de Saúde', desc: 'Check-up completo com análise dos aspectos físicos, emocionais e sociais, gerando um panorama da sua saúde.' },
  { icon: 'ri-leaf-line', title: 'Longevidade e Qualidade de Vida', desc: 'Orientações baseadas em evidências para envelhecer com saúde, vitalidade e independência.' },
  { icon: 'ri-team-line', title: 'Apoio ao Cuidador', desc: 'Orientação e suporte para familiares e cuidadores de idosos, garantindo segurança no acompanhamento.' },
];

export default function ServicesSection() {
  return (
    <section id="servicos" className="py-24 bg-[#F5F5F0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-10 h-[2px] bg-gradient-to-r from-[#4F5D4A] to-[#6B705C]"></div>
            <span className="text-sm font-semibold text-[#6B705C] uppercase tracking-wider">Especialidades</span>
            <div className="w-10 h-[2px] bg-gradient-to-l from-[#4F5D4A] to-[#6B705C]"></div>
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-[#3A3A3A] mb-4">
            Áreas de <span className="text-[#6B705C]">cuidado</span>
          </h2>
          <p className="text-base text-[#3A3A3A]/60 max-w-2xl mx-auto">
            Atendimento integral focado em longevidade, prevenção e qualidade de vida
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((s) => (
            <div
              key={s.title}
              className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer border border-[#DDE0D7]/50 group"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-[#4F5D4A] to-[#6B705C] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${s.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-[#3A3A3A] mb-3">{s.title}</h3>
              <p className="text-sm text-[#3A3A3A]/60 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}